import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Button } from '../../common/html/button'
import { Icon } from '../../common/html/icon'
import classes from './NewsAndSocialContent.module.scss'
import { FilterListCheckbox } from './common/FilterListCheckbox'
import { FilterListTimePeriodRadio } from './common/FilterListTimePeriodRadio'
import { TIME_PERIOD_LIST } from './constants'
import { getParentChecked, handleOptions } from './helpers'
import {
  changeActiveTimePeriod,
  changeIsBookmark,
  changeLanguages,
  changeNewsTypes,
  changeSentiments,
  selectIsBookmark,
  selectLanguages,
  selectNewsType,
  selectSentiments,
} from './store/slice'

export const NewsFilter = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const newsTypes = useSelector(selectNewsType)
  const sentiments = useSelector(selectSentiments)
  const isBookmark = useSelector(selectIsBookmark)
  const languages = useSelector(selectLanguages)
  const { newsTypeId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const newsTypesOptions = newsTypes.map((item) => {
    return {
      children: item.children.map((child) => ({
        name: child.newsCategoryName,
        value: child.newsCategoryId,
        isChecked: child.isChecked,
      })),
      name: item.newsCategoryName,
      value: item.newsCategoryId,
      isChecked: item.isChecked,
    }
  })

  const sentimentsOptions = sentiments.map((item) => {
    return {
      name: item.newsTypeName,
      value: item.newsTypeId,
      isChecked: item.isChecked,
    }
  })

  useEffect(() => {
    onCheckboxNewsTypesChange(+newsTypeId, true)
  }, [newsTypeId])

  const onResetDefault = () => {
    const newsTypesList = handleOptions(newsTypes)
    const newSentiments = handleOptions(sentiments)

    dispatch(changeNewsTypes(newsTypesList))
    dispatch(changeSentiments(newSentiments))
    dispatch(changeActiveTimePeriod(TIME_PERIOD_LIST.allTime))
    dispatch(changeIsBookmark(false))
    dispatch(
      changeLanguages(languages.map((item) => ({ ...item, isChecked: false }))),
    )
  }

  const changeBookmark = () => {
    dispatch(changeIsBookmark(!isBookmark))
  }

  const onCheckboxNewsTypesChange = (value, isChecked) => {
    const options = newsTypesOptions.map((item) => {
      const children = item.children.map((child) => ({
        newsCategoryId: child.value,
        newsCategoryName: child.name,
        isChecked: value === item.value ? isChecked : child.isChecked,
      }))

      return {
        children,
        newsCategoryId: item.value,
        newsCategoryName: item.name,
        isChecked: value === item.value ? isChecked : item.isChecked,
      }
    })

    dispatch(changeNewsTypes(options))
  }

  const onCheckboxEventsChange = (value, isChecked) => {
    const options = newsTypesOptions.map((item) => {
      const children = item.children.map((child) => ({
        newsCategoryId: child.value,
        newsCategoryName: child.name,
        isChecked: child.value === value ? isChecked : child.isChecked,
      }))

      return {
        children,
        newsCategoryId: item.value,
        newsCategoryName: item.name,
        isChecked: item.children.every((child) => child.value !== value)
          ? item.isChecked
          : getParentChecked(children),
      }
    })

    dispatch(changeNewsTypes(options))
  }

  const onCheckboxSentimentsChange = (value, isChecked) => {
    const newSentiments = sentimentsOptions.map((item) => {
      return {
        newsTypeId: item.value,
        newsTypeName: item.name,
        isChecked: item.value === value ? isChecked : item.isChecked,
      }
    })

    dispatch(changeSentiments(newSentiments))
  }

  const onChangeLanguage = (value, isChecked) => {
    const newLanguages = languages.map((item) => {
      return {
        ...item,
        isChecked: item.value === value ? isChecked : item.isChecked,
      }
    })
    dispatch(changeLanguages(newLanguages))
  }

  const renderTopComponent = () => {
    return (
      <div className={classes.buttonResetContainer}>
        <Button
          label={
            <span className="dFlex alignItemsCenter justifyContentCenter">
              <Icon className="icon-reset" />
              &nbsp;
              <Translate value="newsAndSocial.RESET" />
            </span>
          }
          style={{ color: '#fff', backgroundColor: '#0553A5' }}
          className={['w100 cursorPointer', classes.buttonReset].join(' ')}
          action={onResetDefault}
        />
      </div>
    )
  }

  return (
    <>
      {renderTopComponent()}
      <div className={classes.searchFilterContent}>
        <FilterListCheckbox
          title="newsAndSocial.LANGUAGE"
          options={languages}
          onChange={onChangeLanguage}
        />
        <FilterListCheckbox
          title="newsAndSocial.VIEW_BY"
          options={[
            {
              name: 'newsAndSocial.BOOKMARK',
              value: 1,
              isChecked: isBookmark,
            },
          ]}
          onChange={changeBookmark}
        />
        <FilterListCheckbox
          title="newsAndSocial.NEWS_TYPES"
          options={newsTypesOptions}
          onChange={onCheckboxNewsTypesChange}
          onChangeOfChildren={onCheckboxEventsChange}
        />
        <FilterListTimePeriodRadio title={'newsAndSocial.TIME_PERIOD'} />
        <FilterListCheckbox
          title="newsAndSocial.SENTIMENTS"
          options={sentimentsOptions}
          onChange={onCheckboxSentimentsChange}
        />
      </div>
    </>
  )
}
